import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'changeDotMoney',
  standalone:true
})
export class ChangeDotMoneyPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(value: number, currencyCode: string = 'BRL'): string {
    if (value == null) return '';

    // Formata o número com o CurrencyPipe padrão
    let formatted = this.currencyPipe.transform(value, currencyCode, 'symbol', '1.2-2') || '';

    // Inverte os separadores (ponto vira vírgula e vice-versa)
    return formatted.replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',');
  }
}
